import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, BottomNav } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { OnboardingStatusBar } from "@/components/onboarding/OnboardingStatusBar";

export function AppShell() {
  return (
    <div className="flex h-[100dvh] w-full overflow-hidden bg-background">
      <Sidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Topbar />
        <OnboardingStatusBar />
        <main className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto scroll-thin pb-16 lg:pb-0">
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
